<template>
  <div
    class="locale-select u-typography-helvetica u-text u-text--link u-text--s"
    @click="openModal"
  >
    {{ displayCountry }} — {{ displayLocale }}
    <locale-select-modal ref="localeSelectModal" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import { ellipsis } from 'universkin-shared/src/utils/textFormat';

import LocaleSelectModal from '@/components/header/LocaleSelectModal.vue';
import { displayNameMixin } from '@/mixins/displayNameMixin';

import { LOCALE_LABEL } from '@/constants/locale';
import { types } from '@/store/types';

export default {
  name: 'LocaleSelect',
  components: { LocaleSelectModal },
  mixins: [displayNameMixin],
  computed: {
    ...mapState({
      selectedLocale: types.state.LOCALE
    }),
    ...mapGetters({
      selectedCountryCode: types.getters.DELIVERY_COUNTRY
    }),
    displayCountry() {
      return ellipsis(this.getCountryDisplayName(this.selectedCountryCode), 18);
    },
    displayLocale() {
      return LOCALE_LABEL[this.selectedLocale];
    }
  },
  methods: {
    openModal() {
      return this.$refs.localeSelectModal.open();
    }
  }
};
</script>

<style lang="scss" scoped>
.locale-select {
  cursor: pointer;
}
</style>
